/**
 * Converts strings from something to camel case
 * http://stackoverflow.com/questions/10425287/convert-dash-separated-string-to-camelcase
 */
export function camelCase(str: string): string {
  // Replace special characters with a space
  str = str.replace(/[^a-zA-Z0-9 ]/g, ' ');
  // put a space before an uppercase letter
  str = str.replace(/([a-z](?=[A-Z]))/g, '$1 ');

  // Lower case first character and some other stuff
  str = str
    .replace(/([^a-zA-Z0-9 ])|^\d+/g, '')
    .trim()
    .toLowerCase();

  // uppercase characters preceded by a space or number
  // Option A: Use fixed-length lookbehind to uppercase letters preceded by space or digit, then strip spaces.
  str = str.replace(/(?<=[ \d])[a-zA-Z]/g, c => c.toUpperCase());
  str = str.replace(/ +/g, '');

  return str;
}

/**
 * Converts strings from camel case to words
 * http://stackoverflow.com/questions/7225407/convert-camelcasetext-to-camel-case-text
 */
export function deCamelCase(str: string): string {
  return str.replace(/([A-Z])/g, match => ` ${match}`).replace(/^./, match => match.toUpperCase());
}
